import { LocationObject } from '../../../../swagger-api';
import { replaceAll } from '../../../../common/app.helpers';

export function getStringRepresentationOfLocation(location?: LocationObject): string {
  const dataValue: string =
    location !== null && location
      ? (location.street ? `${location.street}, ` : '') +
        (location.city ? `${location.city}, ` : '') +
        (location.subregion ? `${location.subregion}, ` : '') +
        (location.region ? `${location.region}, ` : '') +
        (location.country ? `${location.country.full_name}` : '')
      : '';
  return replaceAll(dataValue, '&#8217;', `'`);
}
